// 是否正式环境
const isPord = process.env.NODE_ENV === 'production'

// 学校后台注册入口
export const speecheduUrl = isPord ? 'https://edu.chineserd.com/schoolInformation' : 'https://edutest.chineserd.com/schoolInformation'
// export const speecheduUrl = isPord ? 'https://speechedu.chineserd.com/user/login' : 'https://speechedu.zhixin2018.cn/user/register?redirect=true'